import React from "react";
import testimonialsAvatarOne from "../../../assets/images/webp/testimonials-avatar-2.webp";
import testimonialsAvatarTwo from "../../../assets/images/webp/testimonials-avatar-3.webp";
import testimonialsAvatarThree from "../../../assets/images/webp/testimonials-avatar-4.webp";
import testimonialsAvatarFour from "../../../assets/images/webp/testimonials-avatar-5.webp";
import testimonialsAvatarFive from "../../../assets/images/webp/testimonials-avatar-6.webp";
import testimonialsAvatarSix from "../../../assets/images/webp/testimonials-avatar-7.webp";
import testimonialsBg from "../../../assets/images/webp/testimonials-bg.webp";
import Icons from "../../common/components/Icons";
import BlueTag from "../../common/ui/BlueTag";
import Heading from "../../common/ui/Heading";
import Paragraph from "../../common/ui/Paragraph";
import SideAvatars from "./SideAvatars";
import Slider from "./Slider";

const Testimonials = ({
  isMax = false,
  badge = "Client Reviews",
  title = "Testimonials",
  description = "   Our clients trust us because we deliver quality services and solutions that exceed expectations. Here are some of their experiences:",
}) => {
  return (
    <div
      id="testimonials"
      className="relative pt-[270px] pb-[170px] max-w-[1920px] mx-auto max-xl:pt-[200px] max-lg:pb-[65px] overflow-clip max-lg:pt-20  max-md:pt-[105px]">
      <img
        className="absolute left-1/2 -translate-x-1/2 max-w-[1222px] min-h-[1184px] pointer-events-none top-[8%] max-md:top-[6%] max-lg:-bottom-[10%] w-full max-lg:min-w-[822px] max-lg:min-h-[915px]"
        src={testimonialsBg}
        alt="testimonials img"
      />

      <SideAvatars
        className="absolute left-[18%] top-[55%] max-w-[60px] max-lg:max-w-10 pointer-events-none max-xl:top-[53%] max-xl:left-[9%] max-lg:top-[46%] max-lg:left-[12%]"
        src={testimonialsAvatarOne}
        alt="testimonials img"
      />

      <SideAvatars
        className="absolute left-[21%] top-[67%] max-xl:left-[14%] max-xl:top-[64%] max-w-[60px] max-lg:max-w-10 pointer-events-none max-lg:top-[59%] max-lg:left-[5%] max-md:top-[57%]"
        src={testimonialsAvatarTwo}
        alt="testimonials img"
      />

      <SideAvatars
        className="absolute left-[14%] bottom-[21%] max-w-[60px] max-lg:max-w-10 pointer-events-none max-xl:left-[8%] max-lg:bottom-[19%] max-md:left-[4%]"
        src={testimonialsAvatarThree}
        alt="testimonials img"
      />

      <SideAvatars
        className="absolute right-[23%] top-[56%] max-w-[60px] max-lg:max-w-10 pointer-events-none max-xl:right-[18%] max-xl:top-[52%] max-lg:top-[49%] max-lg:right-[15%]"
        src={testimonialsAvatarFour}
        alt="testimonials img"
      />

      <SideAvatars
        className="absolute right-[11%] top-[68%] max-w-[60px] max-lg:max-w-10 pointer-events-none max-xl:right-[9%] max-xl:top-[63%] max-lg:top-[60%] max-lg:right-[5%]"
        src={testimonialsAvatarSix}
        alt="testimonials img"
      />

      <SideAvatars
        className="absolute right-[19%] bottom-[18%] max-xl:right-[14%] max-w-[60px] max-lg:max-w-10 pointer-events-none max-lg:bottom-[24%] max-lg:right-[6%] max-md:right-[2%] max-md:bottom-[18%]"
        src={testimonialsAvatarFive}
        alt="testimonials img"
      />

      <div className="container text-center max-md:px-8">
        <div className={` mx-auto ${isMax && "max-w-[589px]"}`}>
          <BlueTag center>{badge}</BlueTag>
          <Heading className="pt-1 pb-3">{title}</Heading>
          <Paragraph>{description}</Paragraph>
          <div className="flex items-center justify-center pt-3 pb-2 gap-x-px">
            {[...Array(5)].map((_, index) => (
              <Icons key={index} icon="golden-star" x />
            ))}
          </div>
          <Paragraph className="xl:text-lg">
            5.0 rating from 58 reviews
          </Paragraph>
          <Slider />
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
